import React, { useState, useEffect } from 'react';
import notificationService from '../services/notificationService';
import './Notification.css';

const Notification = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const unsubscribe = notificationService.subscribe(setNotifications);
    return unsubscribe;
  }, []);

  const handleRemove = (id) => {
    notificationService.removeNotification(id);
  };

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return 'fas fa-check-circle';
      case 'error':
        return 'fas fa-exclamation-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'loading':
        return 'fas fa-spinner fa-spin';
      default:
        return 'fas fa-info-circle';
    }
  };

  if (notifications.length === 0) return null;

  return (
    <div className="notification-container">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`notification notification-${notification.type}`}
        >
          <div className="notification-content">
            <div className="notification-icon">
              <i className={getIcon(notification.type)}></i>
            </div>
            <div className="notification-text">
              {notification.title && (
                <div className="notification-title">{notification.title}</div>
              )}
              <div className="notification-message">{notification.message}</div>
            </div>
            <button
              className="notification-close"
              onClick={() => handleRemove(notification.id)}
              aria-label="Close notification"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
          {notification.duration > 0 && (
            <div className="notification-progress">
              <div
                className="notification-progress-bar"
                style={{
                  animationDuration: `${notification.duration}ms`,
                }}
              ></div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Notification;
